import React, { forwardRef } from 'react';
import NumberFormat from 'react-number-format'

const TextInput = forwardRef((props, ref) => {
    return (
        <input ref={ref} className="w-full block h-8- py-2 text-gray-700 pr-2 bg-gray-200 rounded text-sm focus:outline-none focus:bg-white focus:border-gray-300 border border-gray-100 leading-tight" {...props}></input>
    );
})

export const NumFormat = forwardRef((props, ref) => {
    return (
        <NumberFormat
            className="w-full block h-8- py-2 text-gray-700 pr-2 bg-gray-200 rounded text-sm focus:outline-none focus:bg-white focus:border-gray-300 border border-gray-100 leading-tight"
            thousandSeparator
            getInputRef={ref}
            {...props}
        />
    )
})

export default TextInput;